import { render } from "./ProgramEditTags.vue?vue&type=template&id=15fd946f&scoped=true&ts=true"
import script from "./ProgramEditTags.vue?vue&type=script&lang=ts"
export * from "./ProgramEditTags.vue?vue&type=script&lang=ts"

import "./ProgramEditTags.vue?vue&type=style&index=0&id=15fd946f&scoped=true&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15fd946f"]])

export default __exports__